var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 7.00391C3.375 4.00906 5.92109 1.625 9 1.625C12.0789 1.625 14.625 4.00906 14.625 7.00391C14.625 8.69227 13.7121 10.7811 12.7122 12.5867C11.6972 14.4192 10.5283 16.0703 9.90146 16.9168C9.79803 17.0582 9.66278 17.1733 9.50663 17.2528C9.34969 17.3326 9.17609 17.3743 9 17.3743C8.82391 17.3743 8.65031 17.3326 8.49337 17.2528C8.3372 17.1733 8.20194 17.0582 8.0985 16.9168C7.47168 16.0699 6.30279 14.4182 5.28782 12.5854C4.28789 10.7798 3.375 8.69107 3.375 7.00391ZM9 2.75C6.48907 2.75 4.5 4.68242 4.5 7.00391C4.5 8.37534 5.27461 10.2394 6.27199 12.0404C7.25166 13.8095 8.38638 15.4145 9 16.2437C9.6136 15.4149 10.7483 13.8104 11.728 12.0416C12.7254 10.2409 13.5 8.3766 13.5 7.00391C13.5 4.68242 11.5109 2.75 9 2.75Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.125C8.37868 6.125 7.875 6.62868 7.875 7.25C7.875 7.87132 8.37868 8.375 9 8.375C9.62132 8.375 10.125 7.87132 10.125 7.25C10.125 6.62868 9.62132 6.125 9 6.125ZM6.75 7.25C6.75 6.00736 7.75736 5 9 5C10.2426 5 11.25 6.00736 11.25 7.25C11.25 8.49264 10.2426 9.5 9 9.5C7.75736 9.5 6.75 8.49264 6.75 7.25Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dea9741dc67668eeb2ae4a334fc53076.svg";
export { ForwardRef as ReactComponent };